import styles from './feedback.module.css';
import { cx } from './cx';

/**
 * `aria-hidden`, always: a spinner is a picture of waiting. The *sentence* beside it ("Loading…") is
 * what a screen reader should read, and announcing both says it twice.
 *
 * A `<span>`, not a `<div>` — a button's content model is phrasing content, and the busy face of a
 * "Try again" button is exactly where this ends up. `small` is that face's size: 1em, so it tracks
 * whatever type it sits beside.
 */
export function Spinner({ small }: { readonly small?: boolean }) {
  return <span className={cx(styles.spinner, small === true && styles.spinnerSm)} aria-hidden="true" />;
}

/**
 * A placeholder block for content that has not arrived. Sized by the caller — a skeleton that guesses
 * its own dimensions is a skeleton that reflows the page when the real thing lands.
 */
export function Skeleton({
  width,
  height,
  radius,
  text,
  className,
}: {
  readonly width?: string;
  readonly height?: string;
  /** For a thumbnail box, which is `radius.md` rather than the default hairline radius. */
  readonly radius?: string;
  /** One line of text: takes the current font's height so it sits on the same rhythm. */
  readonly text?: boolean;
  readonly className?: string;
}) {
  return (
    <div
      className={cx(styles.skeleton, text === true && styles.text, className)}
      style={{ width, height, borderRadius: radius }}
      aria-hidden="true"
    />
  );
}
